import React from 'react';
import {
  Box,
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  Link,
} from '@mui/material';
import { Phone as PhoneIcon, Email as EmailIcon } from '@mui/icons-material';
import { motion } from 'framer-motion';

const Contact = () => {
  return (
    <Box>
      {/* Hero Section */}
      <Box
        sx={{
          position: 'relative',
          overflow: 'hidden',
          background: 'linear-gradient(135deg, #7f1d1d, #991b1b, #c2410c)',
          py: { xs: 10, lg: 16 },
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            inset: 0,
            backgroundImage: 'url("/grid.svg")',
            opacity: 0.1,
          }}
        />

        <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 20 }}>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <Box sx={{ textAlign: 'center' }}>
              <Typography
                variant="h1"
                sx={{
                  color: 'white',
                  mb: 3,
                  textShadow: '0 4px 6px rgba(0,0,0,0.1)',
                  fontSize: { xs: '2.5rem', md: '3.75rem' },
                }}
              >
                Contact Us
              </Typography>
              <Typography
                variant="h5"
                sx={{
                  color: '#fed7aa',
                  maxWidth: 800,
                  mx: 'auto',
                  textShadow: '0 2px 4px rgba(0,0,0,0.1)',
                }}
              >
                Get in touch with Chennai Anti Bribe Movement
              </Typography>
            </Box>
          </motion.div>
        </Container>
      </Box>

      {/* Contact Information */}
      <Box sx={{ py: 10, backgroundColor: 'white' }}>
        <Container maxWidth="md">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <Box sx={{ textAlign: 'center', mb: 6 }}>
              <Typography variant="h2" sx={{ mb: 3 }}>
                Get in Touch
              </Typography>
              <Typography variant="h6" color="text.secondary" sx={{ maxWidth: 600, mx: 'auto' }}>
                For any inquiries, complaints, or to report corruption, reach out to us through the
                following contact details.
              </Typography>
            </Box>
          </motion.div>

          <Grid container spacing={4} sx={{ maxWidth: 800, mx: 'auto' }}>
            {/* Phone Number */}
            <Grid item xs={12} md={6}>
              <motion.div
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: 0.1 }}
              >
                <Card
                  sx={{
                    height: '100%',
                    transition: 'box-shadow 0.3s',
                    '&:hover': { boxShadow: 6 },
                    borderLeft: 4,
                    borderColor: 'success.main',
                  }}
                >
                  <CardContent sx={{ p: 4, textAlign: 'center' }}>
                    <Box
                      sx={{
                        backgroundColor: '#dcfce7',
                        p: 2,
                        borderRadius: '50%',
                        width: 64,
                        height: 64,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        mx: 'auto',
                        mb: 3,
                      }}
                    >
                      <PhoneIcon sx={{ fontSize: 32, color: 'success.main' }} />
                    </Box>
                    <Typography variant="h5" fontWeight={700} sx={{ mb: 2 }}>
                      Phone Number
                    </Typography>
                    <Typography variant="body2" color="text.secondary" fontWeight={600} sx={{ mb: 1 }}>
                      ABM Lawyer Vijayarangam
                    </Typography>
                    <Link
                      href="tel:+919952049498"
                      sx={{
                        fontSize: '1.5rem',
                        fontWeight: 700,
                        color: 'success.main',
                        textDecoration: 'none',
                        '&:hover': { color: 'success.dark' },
                      }}
                    >
                      +91 99520 49498
                    </Link>
                  </CardContent>
                </Card>
              </motion.div>
            </Grid>

            {/* Email Address */}
            <Grid item xs={12} md={6}>
              <motion.div
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: 0.2 }}
              >
                <Card
                  sx={{
                    height: '100%',
                    transition: 'box-shadow 0.3s',
                    '&:hover': { boxShadow: 6 },
                    borderLeft: 4,
                    borderColor: 'info.main',
                  }}
                >
                  <CardContent sx={{ p: 4, textAlign: 'center' }}>
                    <Box
                      sx={{
                        backgroundColor: '#dbeafe',
                        p: 2,
                        borderRadius: '50%',
                        width: 64,
                        height: 64,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        mx: 'auto',
                        mb: 3,
                      }}
                    >
                      <EmailIcon sx={{ fontSize: 32, color: 'info.main' }} />
                    </Box>
                    <Typography variant="h5" fontWeight={700} sx={{ mb: 2 }}>
                      Email Address
                    </Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                      General Inquiries & Reports
                    </Typography>
                    <Link
                      href="mailto:tnanitibribemovement@gmail.com"
                      sx={{
                        fontSize: '1.125rem',
                        fontWeight: 700,
                        color: 'info.main',
                        textDecoration: 'none',
                        wordBreak: 'break-all',
                        '&:hover': { color: 'info.dark' },
                      }}
                    >
                      tnanitibribemovement@gmail.com
                    </Link>
                  </CardContent>
                </Card>
              </motion.div>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </Box>
  );
};

export default Contact;

